// extracted by mini-css-extract-plugin
export var infoRow = "_ms-2";
export var labelContainer = "_ms-0";
export var rightInfo = "_ms-1";